import { render, staticRenderFns } from "./BusinessAnnualReturnMessages.vue?vue&type=template&id=75702504&scoped=true&"
import script from "./BusinessAnnualReturnMessages.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75702504",
  null
  
)

export default component.exports